import { Box } from '@mui/material';
import FormPanelButtonUpdateIndexesBase, {
    FormPanelButtonUpdateIndexesControlProps,
} from './FormPanelButtonUpdateIndexesBase';
import { FormPanelButtonProps } from 'components/common/form/index';
import useBundleTranslation from 'i18n';
import { MutableRefObject, ReactElement } from 'react';

export default function FormPanelButtonUpdateIndexes(
    props: FormPanelButtonProps<FormPanelButtonUpdateIndexesControlProps> & {
        confirmationPopupContent?: ReactElement;
        confirmationPopupTitle?: string;
        triggerRef?: MutableRefObject<any>;
    },
) {
    const { t } = useBundleTranslation([props.button.translationNS ?? 'components/common/form/form']);

    return (
        <FormPanelButtonUpdateIndexesBase
            confirmationPopupContent={<Box>{t('proceed_action_description')}</Box>}
            {...props}
            getInitialProgressStatus={(res) => res?.data?.index_status === 'running'}
            getProgressValue={(res) => {
                const status = res?.data?.index_status;
                if (status === 'initiating') return 0;
                if (status === 'running') return Number(res.data.index_progress ?? 0);
                if (status === 'inactive') return 100;
                return null;
            }}
        />
    );
}
